import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

import { FORMAT_DATE } from '../../const';
import {
    CalendarScaleType,
    CalendarViewType,
    HeaderType,
    ItemTaskType,
    ItemType,
    MappingItemIdIndexType,
    ModeShowingTaskType,
    TaskPositionType,
    TaskType,
} from '../../types';
import { hashingData } from './functionSlice';

export interface ICalendarState {
    items: ItemType[];
    tasks: ItemTaskType[];
    filteredItems: ItemType[];
    filteredTasks: ItemTaskType[];
    viewCalendar: CalendarViewType;
    scheduleScale: CalendarScaleType;
    currentDate: string;
    currentIdItem: string;
    currentTask: ItemTaskType | null;
    agendaFilter: HeaderType;
    paddingBottom: number;
    availableHeight: number;
    availableHeightTable: number;
    mappingItemIdIndex: MappingItemIdIndexType;
    isDragging: boolean;
    connectionTaskId: string;
    modeShowingTask: ModeShowingTaskType;
    listTask: TaskType[];
    positioningTasks: TaskPositionType[];
    processedTasksFromServer: ItemTaskType[] | null;
    allowSync: boolean;
}

const initialState: ICalendarState = {
    items: [],
    tasks: [],
    filteredItems: [],
    filteredTasks: [],
    viewCalendar: 'schedule',
    scheduleScale: 'day',
    currentDate: DateTime.now().toFormat(FORMAT_DATE),
    currentIdItem: '',
    agendaFilter: 'day',
    paddingBottom: 0,
    availableHeight: window.innerHeight,
    availableHeightTable: window.innerHeight,
    mappingItemIdIndex: {},
    currentTask: null,
    isDragging: false,
    connectionTaskId: '',
    modeShowingTask: 'Outstanding',
    listTask: [],
    positioningTasks: [],
    processedTasksFromServer: null,
    allowSync: false,
};

const storeHash: { [key: string]: number } = {};

export const calendarSlice = createSlice({
    name: 'calendar',
    initialState,
    reducers: {
        setterCalendar: (state, action: PayloadAction<Partial<ICalendarState>>) => {
            if (action.payload.allowSync === undefined) {
                action.payload.allowSync = false;
            }

            hashingData(storeHash, action.payload, 'items');
            hashingData(storeHash, action.payload, 'tasks');
            // hashingData(storeHash, action.payload, 'filteredItems');
            hashingData(storeHash, action.payload, 'filteredTasks');
            hashingData(storeHash, action.payload, 'listTask');
            hashingData(storeHash, action.payload, 'positioningTasks');

            if (!Object.keys(action.payload).length) {
                return state;
            }

            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

export const { setterCalendar } = calendarSlice.actions;

export default calendarSlice.reducer;
